import clearAnalyticsEvent from '../utilities/clearAnalyticsEvent';
import { ANALYTICS_EVENT } from './constants';

const globalJumpNavAnalytics = (
    sectionTitle,
    customAnalyticObject = {},
    customAnalyticFields = {}
) => {
    const prevJumpNavIndex = window.dataLayer.findIndex(
        (dataLayer) => dataLayer.event === ANALYTICS_EVENT.PAGE_SECTION_VIEW
    );

    if (
        prevJumpNavIndex > -1 &&
        window.dataLayer[prevJumpNavIndex].data.section_title === sectionTitle
    ) {
        return;
    }

    clearAnalyticsEvent(ANALYTICS_EVENT.PAGE_SECTION_VIEW);
    const gtmGlobalJumpNavAnalytics = {
        event: ANALYTICS_EVENT.PAGE_SECTION_VIEW,
        data: {
            section_title: sectionTitle,
            ...customAnalyticFields,
        },
        ...customAnalyticObject,
    };

    window.dataLayer.push(gtmGlobalJumpNavAnalytics);
};

export default globalJumpNavAnalytics;
